export const TABLE_EVENTS = {
    ROW_CHANGED: 'landr-maestro--table-row-changed',
};
